export enum ThreadSubjectType {
  Company = 'Company',
  Contact = 'Contact',
  PlanTodo = 'PlanTodo',
  Review = 'Review',
  Signal = 'Signal',
}

export enum ThreadContentFormat {
  PlainText = 'plain',
  SlateJson = 'slate',
}

export interface ThreadUser {
  id: number;
  firstName?: string;
  lastName?: string;
  username?: string;
  avatarColor?: string;
}

export interface Thread {
  id: number;
  subjectType: ThreadSubjectType;
  subjectId: number;
  parentId?: number | null;
  userId: number;
  content: string;
  contentFormat: ThreadContentFormat;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  // Associations
  user?: ThreadUser;
  parent?: Thread;
  children?: Thread[];
}

export interface CreateThreadPayload {
  subjectType: ThreadSubjectType;
  subjectId: number;
  parentId?: number | null;
  content: string;
  contentFormat?: ThreadContentFormat;
}
